import { render, staticRenderFns } from "./ShippingDetailsBlock.vue?vue&type=template&id=d82bbc28&scoped=true"
import script from "./ShippingDetailsBlock.vue?vue&type=script&lang=js"
export * from "./ShippingDetailsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82bbc28",
  null
  
)

export default component.exports